import { useTheme, Typography } from "@mui/material";
import { useSocketContext } from "~contexts/Socket";
import { IMessage } from "~contexts/Socket/interfaces";
import { convertToHour } from "~helpers/chat";
import { getStyles } from "./styles";

interface IProps {
  message: IMessage;
}

const MessageHistory = ({ message }: IProps) => {
  const theme = useTheme();
  const { messagesRooms } = useSocketContext();
  const { styles } = getStyles(theme);
  const rooms: IMessage[] = Array.from(messagesRooms.get(message.privateRoom));

  const messagesBeforeReply = rooms.filter(
    (msg: IMessage) =>
      new Date(msg.time).toLocaleTimeString() <
      new Date(message.time).toLocaleTimeString()
  );

  return (
    <div style={styles.wrapper}>
      {messagesBeforeReply.map((msg: IMessage, index) => (
        <div key={index}>
          <Typography component={"span"} sx={styles.name}>
            <div>
              <strong>{msg.name}</strong> ({msg.email})
            </div>
            {convertToHour(msg.time)}
          </Typography>

          <Typography style={styles.text}>{msg.text}</Typography>
        </div>
      ))}
    </div>
  );
};

export default MessageHistory;
